import Vue from "vue";
import VueGlide from "vue-glide-js";
import BackToTop from "vue-backtotop";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import VueTheMask from "vue-the-mask";
import UniqueId from "vue-unique-id";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import "vue-glide-js/dist/vue-glide.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

Vue.use(UniqueId);
Vue.use(BackToTop);
Vue.use(VueGlide);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueTheMask);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBnvVjl76thlD5Uh8lzwBpypHfFbAe52Vw",
    libraries: "places",
  },
});
Vue.config.productionTip = false;

firebase.initializeApp({
  apiKey: "AIzaSyBZqdArQjYAv42SWF1cVgNQRsA1GsuTZxg",
  authDomain: "business-debt-adjusters.firebaseapp.com",
  databaseURL: "https://business-debt-adjusters.firebaseio.com",
  projectId: "business-debt-adjusters",
  storageBucket: "business-debt-adjusters.appspot.com",
  messagingSenderId: "242497443766",
  appId: "1:242497443766:web:150bacb4e26b004d0f5317",
  measurementId: "G-D16GBS6CGD",
});

firebase.analytics()

Vue.prototype.$analytics = firebase.analytics();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
